export var BulkDownloadsType;
(function (BulkDownloadsType) {
    BulkDownloadsType["TaxCertificates"] = "tax-certificates";
    BulkDownloadsType["TaxReports"] = "tax-reports";
    BulkDownloadsType["InvestorReports"] = "investor-reports";
    BulkDownloadsType["ExitStatements"] = "exit-statements";
    BulkDownloadsType["CustomUpdates"] = "custom-updates";
    BulkDownloadsType["DeploymentUpdates"] = "deployment-updates";
})(BulkDownloadsType || (BulkDownloadsType = {}));
//# sourceMappingURL=api.js.map